import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Container,
  Card,
  ListGroupItem,
  ListGroup,
  Spinner,
  Collapse
} from "reactstrap";
import _ from "lodash";
import API from "services/WebAPI";
import EditHook from "./edit";

const ListItem = ({ data, update }) => {
  const [open, setOpen] = useState(false)
  return <ListGroupItem>

    <Collapse isOpen={open}>
      <EditHook data={data} open={open} onClose={() => setOpen(false)} update={update} />
    </Collapse>
    {!open && <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {data.Url}
      <Button onClick={() => setOpen(!open)} size="sm" outline color="secondary">
        <i class="fas fa-pen" />
      </Button>
    </div>}
  </ListGroupItem>
}

const WebHooks = () => {
  const history = useHistory();

  const [hooks, setHooks] = useState([]);
  const [hookLoading, setHookLoading] = useState(false);

  useEffect(() => {
    loadWebHooks();
  }, []);

  const loadWebHooks = async () => {
    setHookLoading(true);
    try {
      const res = await API.get("Event/FetchAllPortalEvents/");
      if(res.data.status){
        setHooks(res.data.result)
      }
    } catch (error) {
      console.log("error", error);
    }
    setHookLoading(false);
  };

  return (
    <>
      <Container className="container-main" fluid>
        <div className="common-headers">
          <Button
            className="common-btn-back mr-2"
            outline
            onClick={() => history.go("-1")}
          >
            <i className="fas fa-chevron-left" />
          </Button>
          Web Hooks
        </div>
        <Card style={{ padding: 10 }}>
          <EditHook isNew update={loadWebHooks} />
        </Card>
        <Card style={{ marginTop: 10, padding: 10 }}>
          Configured hooks
          <ListGroup style={{ marginTop: 3 }}>
            {hookLoading && (
              <ListGroupItem>
                <Spinner color="primary" size="sm" />
              </ListGroupItem>
            ) || hooks.map((h) => (<ListItem data={h} update={loadWebHooks} />))}
          </ListGroup>
        </Card>
      </Container>
    </>
  );
};

export default WebHooks;
